module.exports = __webpack_public_path__ + "static/media/3233.d82c997a.jpg";